"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsHeader = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const typography_1 = require("../typography");
const layout_1 = require("../layout");
const styled_1 = __importDefault(require("../../styles/styled"));
function TabsHeader({ tabs, activeTab, setActiveTab, isSmallScreen, dataTestId, }) {
    return ((0, jsx_runtime_1.jsx)(layout_1.Box, Object.assign({ minHeight: "1px", "data-testid": dataTestId, style: {
            paddingBottom: '16px',
        } }, { children: (0, jsx_runtime_1.jsx)(TabsRow, { children: tabs.map(tab => ((0, jsx_runtime_1.jsx)(Tab, { title: tab.title, isActive: activeTab === tab.key, onSelectNewTab: () => setActiveTab(tab.key), isSmallScreen: isSmallScreen }, tab.title))) }) })));
}
exports.TabsHeader = TabsHeader;
const TabsRow = (0, styled_1.default)(layout_1.Row)(({ theme }) => ({
    display: 'inline-flex',
    position: 'sticky',
    top: '0',
    backgroundColor: theme.colors.white,
    width: '100%',
    zIndex: 1,
}));
const Tab = ({ title, isActive = false, onSelectNewTab, isSmallScreen }) => {
    return ((0, jsx_runtime_1.jsxs)(TabWrapper, Object.assign({ onClick: onSelectNewTab, isActive: isActive, isSmallScreen: isSmallScreen, "data-testid": title }, { children: [(0, jsx_runtime_1.jsx)(layout_1.Row, Object.assign({ alignItems: 'center', minHeight: '35px' }, { children: (0, jsx_runtime_1.jsx)(typography_1.AppText, Object.assign({ as: "h3", bold: true, color: isActive ? 'azure' : 'grey60', headingFontFamily: true }, { children: title })) })), isActive && (0, jsx_runtime_1.jsx)(DecorativeUnderline, { isActive: isActive })] })));
};
const TabWrapper = styled_1.default.button(({ theme, isActive, isSmallScreen }) => ({
    padding: '0px',
    ':not(:first-of-type)': {
        marginLeft: isSmallScreen ? theme.spacing.s : theme.spacing.m,
    },
    ':not(:last-child)': {
        marginRight: isSmallScreen ? theme.spacing.s : theme.spacing.m,
    },
    ':hover': {
        cursor: 'pointer',
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: 'none',
    background: 'none',
    'h3:not(:first-of-type)': {
        marginLeft: theme.spacing.s,
    },
    color: isActive ? theme.colors.azure : 'inherit',
}));
const DecorativeUnderline = styled_1.default.div(({ isActive, theme }) => ({
    marginTop: theme.spacing.s,
    marginBottom: '-1px',
    width: '100%',
    height: '2px',
    backgroundImage: isActive ? theme.gradients.lightGradient : 'none',
}));
//# sourceMappingURL=tabs_header.js.map